import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { useMutation, useQuery } from '@apollo/client';
import { useNavigate } from 'react-router-dom'; // Poprawiono podwójny import
import { GET_WISHLIST_PRODUCTS } from '../components/PersonalArea/PersonalAreaWishlist/wishlistQuery';
import { GENERATE_TOKEN, REVOKE_TOKEN } from '../queries/auth';
import { GET_CART } from '../queries/cart';
import { GET_CARD, GET_CUSTOMER } from '../queries/customer';
import { useCartContext } from "./CartContext";

const Context = createContext();

export const useUserContext = () => {
  return useContext(Context);
};

export const UserProvider = ({ children }) => {
  const navigate = useNavigate(); // Poprawiono na pojedynczy import
  const { cart, refetchCart } = useCartContext();

  const [compare, setCompare] = useState([]);
  const userResult = useQuery(GET_CUSTOMER, { 
    ssr: false,
    errorPolicy: 'ignore'
  });
  const userData = userResult.data && userResult.data.customer;
  const { data: card } = useQuery(GET_CARD, {
    fetchPolicy: 'no-cache',
    skip: !userData,
  });

  useEffect(() => {
    refetchCart();
  }, [userData, refetchCart]); // Dodano refetchCart do zależności

  const { success } = (card && card.historyCustomerLoyaltyCard) || {};
  const [generateToken, generateResult] = useMutation(GENERATE_TOKEN, {
    refetchQueries: [
      { query: GET_CUSTOMER },
      { query: GET_CART },
      { query: GET_WISHLIST_PRODUCTS },
    ],
  });

  const [revokeToken, revokeResult] = useMutation(REVOKE_TOKEN, {
    refetchQueries: [
      { query: GET_CUSTOMER },
      { query: GET_CART },
      { query: GET_WISHLIST_PRODUCTS },
    ],
  });

  const logIn = useCallback(
      async (email, password) => {
        const result = await generateToken({
          variables: {
            email,
            password,
          },
        });
        if (result.data?.generateCustomerToken?.token) {
          // Ręczne wywołanie refetch dla GET_CUSTOMER
          await userResult.refetch();
        }
        return result;
      },
      [generateToken] // Usunięto navigate z zależności, bo nie jest używane w funkcji
  );

  const logOut = useCallback(async () => {
    const result = await revokeToken();
    navigate('/customer/account/logoutSuccess');
    return result;
  }, [revokeToken, navigate]);

  const store = {
    refetchUser: userResult.refetch,
    user: userData,
    loading: userResult.loading || generateResult.loading || revokeResult.loading,
    error: generateResult.error,
    userStatus: userResult.networkStatus,
    isLoyaltyCardActive: success,
    cart,
    logIn,
    logOut,
    compare,
    setCompare
  };

  return <Context.Provider value={store}>{children}</Context.Provider>;
};

export default UserProvider; // Dodano domyślny eksport (opcjonalne)